import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ScrollService implements OnDestroy {
  public obsFetchData = new Subject<boolean>();
  public waitingForDataFetch = false;
  public obsShowBackToTop = new Subject<boolean>();
  private showBackToTopBtnClicked: boolean = false;

  public constructor() {
    window.addEventListener('scroll', this.registerScroll, false);
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.registerScroll, false);
  }

  private registerScroll = () => {
    const currentY = window.scrollY;
    const pageY = document.body.offsetHeight - window.innerHeight;

    if (currentY == 0) {
      this.showBackToTopBtnClicked = false;
      this.obsShowBackToTop.next(false);
    }

    if (currentY > 1.9 * window.innerHeight && !this.showBackToTopBtnClicked) {
      this.showBackToTopBtnClicked = !this.showBackToTopBtnClicked;
      this.obsShowBackToTop.next(true);
    }

    const perc = (100 * currentY) / pageY;

    if (perc >= 90 && !this.waitingForDataFetch) {
      this.obsFetchData.next(true);
      this.waitingForDataFetch = true;
    }
  };
}
